import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function SelectOfficeType({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  errorFormik,
  helperText,
  disabled,
  sx = { width: "100%" },
}) {
  const axiosPrivate = useAxiosPrivate([]);
  const [officeTypes, setOfficeTypes] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGetAll = () => {
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/office/getAllOfficeTypes`)
      .then((e) => {
        setOfficeTypes(e?.data);
      })
      .catch((err) => {
        setError(err.message);
        // console.log("ServiceSelect: ", err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAll();
  }, []);

  const [selectedOfficeType, setSelectedOfficeType] = useState(
    officeTypes?.find((officeType) => officeType.id === value) || null
  );

  useEffect(() => {
    setSelectedOfficeType(
      officeTypes?.find((officeType) => officeType.id === value) || null
    );
  }, [officeTypes]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);
    if (newValue) {
      onChange?.(name, newValue.id || "");
      setSelectedOfficeType(newValue);
    }
  };

  const handleClear = () => {
    onChange?.(name, "");
    setSelectedOfficeType(null);
  };

  console.log(officeTypes);

  return (
    <Box>
      <TextField
        label={error ? `${label} - ${error}` : label}
        placeholder={error ? `${placeholder} - ${error}` : placeholder}
        name={name}
        variant="outlined"
        size="small"
        disabled={error || disabled}
        value={selectedOfficeType && value ? selectedOfficeType.Type : ""}
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={sx}
        InputProps={{
          endAdornment: (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <>
                  {selectedOfficeType && (
                    <IconButton edge="end" onClick={handleClear}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  {!disabled && !error && (
                    <IconButton edge="end" onClick={handleClick}>
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
                </>
              )}
            </>
          ),
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        {officeTypes.map((officeType) => (
          <MenuItem
            sx={{ width: "100%" }}
            key={officeType.id}
            onClick={() => handleClose(officeType)}
          >
            {officeType.type}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
